module.exports = __webpack_public_path__ + "media/icons/finansowanie-menu@2x-b6652a7a.png";